module.exports = __webpack_public_path__ + "img/rakuraku2.a6aa1fba.png";